// extracted by mini-css-extract-plugin
module.exports = {"main-layout__wrapper":"MainLayout_main-layout__wrapper__p6A8i"};